import StatusBadge from "./StatusBadge";
import { ServiceProvider } from "../../../utils/integrationConfigData";
import { toTitleCase } from "../../../utils/Utils";

interface ServiceProviderTableProps {
  providers: ServiceProvider[];
  onRowClick?: (provider: ServiceProvider) => void;
  onEditClick?: (provider: ServiceProvider) => void;
}

const getProviderStatusClass = (status: string) => {
  const normalized = status.trim().toLowerCase();
  if (normalized.includes("active") && !normalized.includes("inactive")) {
    return "ic-provider-status-active";
  }
  if (normalized.includes("inactive")) {
    return "ic-provider-status-inactive";
  }
  return "";
};

const ServiceProviderTable = ({
  providers,
  onRowClick,
  onEditClick,
}: ServiceProviderTableProps) => {
  return (
    <div className="card-content ic-table-wrap">
      <div className="table-responsive">
        <table className="table caption-top">
          <thead>
            <tr>
              <th>Service Provider</th>
              <th>CRD</th>
              <th>DTR</th>
              <th>PAS</th>
              <th>CPT Codes</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {providers.length === 0 ? (
              <tr>
                <td colSpan={7} className="text-center">
                  No service provider found
                </td>
              </tr>
            ) : (
              providers.map((provider) => (
                <tr
                  key={provider.id}
                  className="cursor-pointer"
                  onClick={() => onRowClick?.(provider)}
                >
                  <td>
                    <div className="ic-provider-cell">
                      <div className="ic-provider-name">{provider.name}</div>
                      <div className="ic-provider-path">{provider.path}</div>
                    </div>
                  </td>
                  <td>
                    <StatusBadge status={provider.crd} />
                  </td>
                  <td>
                    <StatusBadge status={provider.dtr} />
                  </td>
                  <td>
                    <StatusBadge status={provider.pas} />
                  </td>
                  <td>{provider.cptCodes}</td>
                  <td>
                    <span className={getProviderStatusClass(provider.status)}>
                      {toTitleCase(provider.status)}
                    </span>
                  </td>
                  <td>
                    <button
                      type="button"
                      className="btn btn-link p-0 ic-table-action-btn"
                      aria-label={`Open ${provider.name}`}
                      title="Open provider"
                      onClick={(event) => {
                        event.stopPropagation();
                        onEditClick?.(provider);
                      }}
                    >
                      <i className="fh_open_in_new" aria-hidden="true"></i>
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ServiceProviderTable;
